import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { clearCurrentDocument, clearDocumentsList, setAiSearchChecked, setAiSearchFeatureEnabled, setDocumentsSearchTerm } from '@lib/medical-documents';
import { Store } from '@ngrx/store';

import { resetMemberHubState } from '@hm/core/stores/member-hub/member-hub.actions';
import { resetPrescriptionsState } from '@hm/core/stores/prescriptions/prescriptions.actions';

import { MemberHubState } from '../models/member-hub.state.interface';

export const clearMemberProfileGuard: CanDeactivateFn<any> = () => {
  const store = inject(Store<MemberHubState>);

  store.dispatch(resetMemberHubState());
  store.dispatch(resetPrescriptionsState());
  store.dispatch(setAiSearchFeatureEnabled({ enabled: false }));
  store.dispatch(setAiSearchChecked({ checked: false }));
  store.dispatch(setDocumentsSearchTerm({ documentsSearchTerm: '' }));
  store.dispatch(clearDocumentsList());
  store.dispatch(clearCurrentDocument());
  return true;
};
